/**
 * Logging Service Types
 * 
 * Type definitions for the logging service.
 */

/**
 * Log levels
 */
export enum LogLevel {
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

/**
 * Log entry structure
 */
export interface LogEntry {
  timestamp: number;
  level: LogLevel;
  message: string;
  metadata?: Record<string, unknown>;
  traceId?: string;
  source?: string;
}

/**
 * Output target interface
 */
export interface LogTarget {
  write(entry: LogEntry): void;
  clear?(): void;
}

/**
 * Logger configuration
 */
export interface LoggerConfig {
  level: LogLevel;
  enableConsole: boolean;
  enableStorage: boolean;
  storageRetention: number; // Max number of logs to keep
  enableRemote: boolean;
  remoteEndpoint?: string;
}

